
import { IOrderForm, IStage, ISubject } from '@/types/placeOrderTypes'
import { ServiceContentEnum } from '@/business/ServiceContent'
import { Component, Vue, Prop } from 'vue-property-decorator'
import { getStage, getSubject } from '@/api/placeOrder'

@Component({})
export default class BasicInfo extends Vue {
  @Prop({}) form!: IOrderForm
  // 校验项目名称是否合法合规
  @Prop() regBookName?: boolean
  // 是否可以更改项目名称
  @Prop() disabledEdit?: boolean
  private stages: IStage[] = []
  private subjects: ISubject[] = []

  get filterSubjects() {
    const supportSubjects: string[] = [
      'chinese',
      'math',
      'english',
      'daode_fazhi',
      'physics',
      'chemistry',
      'biology',
      'history',
      'geography',
      'politics',
      'wen',
      'li',
      'science',
      'computer_science',
    ]
    return this.subjects.filter(item => {
      // 初中生不要政治
      return supportSubjects.includes(item.subject) && !(item.subject === 'politics' && item.stage === 'junior')
    })
  }

  get ServiceContentEnum() {
    return ServiceContentEnum
  }

  async mounted() {
    // 初始化获取学段学科
    if (this.$store.state.stage) {
      this.stages = this.$store.state.stage
    } else {
      this.stages = await getStage()
    }
    if (this.$store.state.subject) {
      this.subjects = this.$store.state.subject
    } else {
      this.subjects = await getSubject()
    }
  }

  bookNameChange(value: string) {
    if (!/^((?!\\|\/|:|\*|\?|"|<|>|\||').)*$/g.test(value)) {
      this.regBookName = true
      return
    } else {
      this.regBookName = false
    }

    this.form.alias = value || ''
  }
}
